import axios from "axios";
import React, { useState, useRef, Fragment } from "react";
import { Grid } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import ReactFullPageLoadinghk from "../../layaout/LoadingFullpagehk";

import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
} from '../../../clientconfigwebapp';


import { Iconbk_trash_red } from '../../../assets/icones/icones';

const Image_Files_Uploads = (props) => {
    const { Data_Full_Get, setActiveTabCurrent } = props;
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");
    const [filesInfo, setFilesInfo] = useState([]);
    const uploadRef = useRef(null);

    const uploadFile = () => {
        const file = uploadRef.current.files[0];
        if (!file) return;

        // Validate file size and type
        const fileSize = file.size / 1024 / 1024; // in MB
        const fileType = file.type;
        const validTypes = ["image/jpeg", "image/jpg"];
        if (fileSize > 5) {
            toast.error("حجم هر تصویر باید کمتر از 5 مگابایت باشد.");
            return;
        }
        if (!validTypes.includes(fileType)) {
            toast.error("تصویر از نوع jpeg یا jpg باشد.");
            return;
        }

        const formData = new FormData();
        formData.append("fileattach", file);

        const xhr = new XMLHttpRequest();
        const index = filesInfo.length;

        xhr.upload.addEventListener("progress", event => updateProgress(event, index));
        xhr.addEventListener("load", event => handleSuccess(event, index));
        xhr.addEventListener("error", () => handleError("Upload failed!!", index));
        xhr.addEventListener("abort", () => handleAbort("Upload aborted!!", index));

        xhr.open("POST", String(clientconfigwebapp.host_dl_get) + "upload-image-prod.php");
        xhr.send(formData);

        setFilesInfo([...filesInfo, { fileName: file.name, progress: 0, status: 'Uploading...' }]);
    };

    const updateProgress = (event, index) => {
        if (!event.lengthComputable) return;
        const percent = Math.round((event.loaded / event.total) * 100);
        setFilesInfo(prevFilesInfo => {
            const updatedFilesInfo = [...prevFilesInfo];
            if (updatedFilesInfo[index]) {
                updatedFilesInfo[index].progress = percent;
                updatedFilesInfo[index].status = `${percent}% uploaded...`;
            }
            return updatedFilesInfo;
        });
    };

    const handleSuccess = (event, index) => {
        const response = JSON.parse(event.target.response || '{}');
        setFilesInfo(prevFilesInfo => {
            const updatedFilesInfo = [...prevFilesInfo];
            if (updatedFilesInfo[index]) {
                updatedFilesInfo[index].progress = 0;
                if (response.data === "success" && response.file_name_get) {
                    updatedFilesInfo[index].fileName = response.file_name_get;
                    updatedFilesInfo[index].status = "";
                    ///updatedFilesInfo[index].status = "Uploaded";
                } else {
                    toast.error(response.msgwebapp || "Upload failed!", toastSettings);
                }
            }
            return updatedFilesInfo;
        });
    };

    const handleError = (message, index) => {
        setFilesInfo(prevFilesInfo => {
            const updatedFilesInfo = [...prevFilesInfo];
            if (updatedFilesInfo[index]) {
                updatedFilesInfo[index].status = message;
            }
            return updatedFilesInfo;
        });
        toast.error(message, toastSettings);
    };

    const handleAbort = (message, index) => {
        setFilesInfo(prevFilesInfo => {
            const updatedFilesInfo = [...prevFilesInfo];
            if (updatedFilesInfo[index]) {
                updatedFilesInfo[index].status = message;
            }
            return updatedFilesInfo;
        });
        toast.error(message, toastSettings);
    };

    const handleClick = () => {
        uploadRef.current.click();
    };

    const toastSettings = {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
    };


    const handleRemove_file = (id_element) => {
        const element = document.getElementById(id_element);
        if (element) {
            element.parentNode.removeChild(element);
        }
    };

    return (
        <Fragment>
            <style jsx>{`
                .fileinput {
                    display: none;
                }

                .upload-button {
                    background-color: #189ddf;
                    color: white;
                    padding: 10px 20px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 16px;
                    font-weight: bold;
                }

                .upload-button:hover {
                    background-color: #1071a1;
                }

        

                .file-item {
                    width: 100%;
                    padding-top: 100%; /* 1:1 Aspect Ratio */
                    position: relative;
                    background-size: cover;
                    background-position: center;
                    background-color: #ccc; /* Fallback color */
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 18px;
                    font-weight: bold;
                    color: white;
                    border: 2px solid #ddd;
                    border-radius: 8px;
                }

                

                .upload-rules {
                    margin-top: 20px;
                    padding: 0;
                    list-style-type: disc;
                    margin-left: 20px;
                }

                .btn-defualt-imageupload,.btn-image-uploaded {
                    background: #F2F3F5;
                    border: 0.523808px solid #CCD4D6;
                    border-radius: 6.2857px;
                    flex: none;
                    order: 0;
                    flex-grow: 1;
                    width: 100%;
                    height: 155px;
                    display: flex;
                    flex-direction: column;
                    align-content: center;
                    justify-content: center;
                    align-items: center;
                    background-size: cover;
                    background-position: center;
                }

                .btn-image-uploaded {
                    filter: brightness(0.8);
                }
                
                .btn-trash-image-uploaded{

                    position: absolute;
                    bottom: 5px;
                    background-color: white;
                    border-radius: 10px;
                    margin-right: 5px;

                }
            `}</style>

            <ReactFullPageLoadinghk loadinghk={loadinghkfullshow} />

            <section className='' style={{
                "display": "flex",
                "flexDirection": "column",
                "alignItems": "flex-end",
                "padding": "16px",
                "gap": "16px",
                "width": "100%",
                "height": "auto",
                "background": "#F9FAFB",
                "borderRadius": "8px",
                "flex": "none",
                "order": "7",
                "alignSelf": "stretch",
                "flexGrow": "0"
            }}>
                <input ref={uploadRef} type="file" className="fileinput" onChange={uploadFile} />

                <Grid container direction="row" className={"file-list"} spacing={2} style={{paddingTop: "14px"}}>
                    <Grid item lg={3} md={3} sm={6} xs={6}>
                        <button type={"button"} onClick={handleClick} className={"btn-defualt-imageupload"}>
                            <svg width="35px" height="35px" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g id="SVGRepo_bgCarrier" strokeWidth={0}/>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                                <g id="SVGRepo_iconCarrier">
                                    <path
                                        d="M14.2647 15.9377L12.5473 14.2346C11.758 13.4519 11.3633 13.0605 10.9089 12.9137C10.5092 12.7845 10.079 12.7845 9.67922 12.9137C9.22485 13.0605 8.83017 13.4519 8.04082 14.2346L4.04193 18.2622M14.2647 15.9377L14.606 15.5991C15.412 14.7999 15.8149 14.4003 16.2773 14.2545C16.6839 14.1262 17.1208 14.1312 17.5244 14.2688C17.9832 14.4253 18.3769 14.834 19.1642 15.6515L20 16.5001M14.2647 15.9377L18.22 19.9628M18.22 19.9628C17.8703 20 17.4213 20 16.8 20H7.2C6.07989 20 5.51984 20 5.09202 19.782C4.7157 19.5903 4.40973 19.2843 4.21799 18.908C4.12583 18.7271 4.07264 18.5226 4.04193 18.2622M18.22 19.9628C18.5007 19.9329 18.7175 19.8791 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V13M11 4H7.2C6.07989 4 5.51984 4 5.09202 4.21799C4.7157 4.40973 4.40973 4.71569 4.21799 5.09202C4 5.51984 4 6.0799 4 7.2V16.8C4 17.4466 4 17.9066 4.04193 18.2622M18 9V6M18 6V3M18 6H21M18 6H15"
                                        stroke="#01a3d4" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                                </g>
                            </svg>
                            <span>افزودن عکس</span>
                        </button>
                    </Grid>


                    {filesInfo.map((file, index) => {

                        const randomId_file_number = Math.floor(Math.random() * 1000000);

                        return (
                            <Grid item lg={3} md={3} sm={6} xs={6} key={index} style={{position:"relative"}} id={"file_image_" +  String(randomId_file_number)}>
                                <input  type={"text"} style={{display:"none"}}  name={"files_images[]"} value={String(file.fileName)}  />
                                <button   type={"button"}  className={"btn-image-uploaded"} style={{backgroundImage: file.fileName ? `url(${clientconfigwebapp.host_dl_get + "uploadsprod/" + String(file.fileName)})` : 'none'}} >

                                    <span>{file.status}</span>
                                    {/*{  file.fileName}*/}
                                    {/*{ clientconfigwebapp.host_dl_get + "uploadsprod/" +  String(file.fileName) }*/}
                                </button>
                                <button onClick={ () => {  handleRemove_file("file_image_" + String(randomId_file_number)) } } className={"btn-trash-image-uploaded"} type={"button"}><Iconbk_trash_red /></button>
                            </Grid>

                        );

                    }

                    )}

                </Grid>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignContent: "center",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        gap: 20
                    }}
                >
                    <ul
                        style={{
                            fontFamily: '"iran"',
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "13px",
                            lineHeight: 2.1,
                            textAlign: "right",
                            color: "#4B5563",
                            flex: "none",
                            order: 0,
                            flexGrow: 0
                        }}
                    >
                        <li> حجم هر تصویر باید کمتر از 5 مگابایت باشد.</li>
                        <li> تصویر از نوع jpeg یا jpg باشد.</li>
                    </ul>
                    <ul
                        style={{
                            fontFamily: '"iran"',
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "13px",
                            lineHeight: 2.1,
                            textAlign: "right",
                            color: "#4B5563",
                            flex: "none",
                            order: 0,
                            flexGrow: 0
                        }}
                    >
                        <li> فقط تصاویر مرتبط با محصول را بارگذاری کنید.</li>
                        <li>از درج شماره تماس یا لوگو بر روی تصاویر خودداری کنید.</li>
                    </ul>
                </div>
            </section>
        </Fragment>
    );
};

export default Image_Files_Uploads;
